export default "__VITE_ASSET__CFxKK79C__"